<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入福利屋名称"
            clearable
            style="width: 220px; margin-right: 10px"
          ></el-input>

          <el-select
            v-model.number="searchParams.type"
            placeholder="请选择周期类型"
            style="width: 180px; margin-right: 10px"
          >
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            />
          </el-select>

          <el-select
            v-model.number="searchParams.status"
            placeholder="请选择状态"
            style="width: 160px; margin-right: 10px"
            clearable
          >
            <el-option label="待开始" :value="0" />
            <el-option label="进行中" :value="1" />
            <el-option label="已结束" :value="2" />
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handleAdd"
            >添加福利屋</el-button
          >

          <el-popover
            placement="bottom"
            title="显示列筛选"
            trigger="click"
            width="220"
          >
            <el-checkbox-group v-model="checkedColumns">
              <el-checkbox
                v-for="item in columnOptions"
                :key="item.prop"
                :label="item.prop"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
            <div style="text-align: right; margin-top: 8px">
              <el-button size="mini" @click="handleCheckAll">全选</el-button>
              <el-button size="mini" @click="handleClearAll">清空</el-button>
            </div>
            <el-button slot="reference" icon="el-icon-s-tools" type="info"
              >列筛选</el-button
            >
          </el-popover>
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handleRowClick"
        >
          <el-table-column
            label="ID"
            prop="id"
            width="80"
            align="center"
            v-if="checkedColumns.includes('id')"
          />
          <el-table-column
            label="福利屋名称"
            prop="name"
            min-width="200"
            v-if="checkedColumns.includes('name')"
          />
          <el-table-column
            label="周期类型"
            prop="room_type_name"
            width="100"
            align="center"
            v-if="checkedColumns.includes('room_type_name')"
          />
          <el-table-column
            label="流水金额"
            prop="amount"
            width="120"
            align="center"
            v-if="checkedColumns.includes('amount')"
          />
          <el-table-column
            label="充值金额"
            prop="recharge_amount"
            width="130"
            align="center"
            v-if="checkedColumns.includes('recharge_amount')"
          />

          <el-table-column
            label="活动状态"
            width="110"
            align="center"
            v-if="checkedColumns.includes('status_text')"
          >
            <template slot-scope="scope">
              <span
                :style="{
                  color:
                    scope.row.status == 0
                      ? '#67C23A'
                      : scope.row.status == 1
                      ? '#409EFF'
                      : '#909399',
                }"
              >
                {{
                  scope.row.status == 0
                    ? "待开始"
                    : scope.row.status == 1
                    ? "进行中"
                    : "已结束"
                }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            label="剩余时间"
            width="220"
            align="center"
            v-if="checkedColumns.includes('remainText')"
          >
            <template slot-scope="scope">
              <span>{{
                formatRemainTime(scope.row.draw_at, scope.row.status)
              }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="开始时间"
            prop="start_at"
            width="180"
            align="center"
            v-if="checkedColumns.includes('start_at')"
          />
          <el-table-column
            label="结束时间"
            prop="end_at"
            width="180"
            align="center"
            v-if="checkedColumns.includes('end_at')"
          />
          <el-table-column
            label="开奖时间"
            prop="draw_at"
            width="180"
            align="center"
            v-if="checkedColumns.includes('draw_at')"
          />
          <el-table-column
            label="创建时间"
            prop="created_at"
            width="180"
            align="center"
            v-if="checkedColumns.includes('created_at')"
          />
          <el-table-column
            label="更新时间"
            prop="updated_at"
            width="180"
            align="center"
            v-if="checkedColumns.includes('updated_at')"
          />

          <el-table-column
            label="操作"
            width="320"
            align="center"
            fixed="right"
            v-if="checkedColumns.includes('action')"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handleEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-box"
                @click.stop="openBoxList(scope.row)"
                >赏品</el-button
              >
              <el-button
                type="text"
                icon="el-icon-user"
                @click.stop="openUserAttendList(scope.row)"
                >参与用户</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                @click.stop="handleDelWealRoom(scope.row)"
                style="color: #f56c6c"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotal"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- ====================== PC 独立弹窗：添加/编辑 ====================== -->
        <el-dialog
          :title="pcForm.room_id ? '编辑福利屋' : '添加福利屋'"
          :visible.sync="pcDialogVisible"
          width="750px"
          @close="resetPcForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="addRules"
            ref="pcFormRef"
            label-width="120px"
          >
            <el-form-item label="福利屋名称" prop="name">
              <el-input
                v-model="pcForm.name"
                placeholder="请输入名称"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="周期类型" prop="type">
              <el-select
                v-model.number="pcForm.type"
                placeholder="请选择周期"
                style="width: 320px"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="流水金额" prop="amount">
              <el-input
                v-model.number="pcForm.amount"
                placeholder="请输入流水金额"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="充值金额" prop="recharge_amount">
              <el-input
                v-model.number="pcForm.recharge_amount"
                placeholder="默认为0"
                style="width: 320px"
              />
            </el-form-item>
            <el-form-item label="活动开始时间" prop="start_at">
              <el-date-picker
                v-model="pcForm.start_at"
                type="datetime"
                placeholder="选择开始时间"
                style="width: 320px"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="活动结束时间" prop="end_at">
              <el-date-picker
                v-model="pcForm.end_at"
                type="datetime"
                placeholder="选择结束时间"
                style="width: 320px"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="开奖时间" prop="draw_at">
              <el-date-picker
                v-model="pcForm.draw_at"
                type="datetime"
                placeholder="选择开奖时间"
                style="width: 320px"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="备注说明" prop="content">
              <el-input
                v-model="pcForm.content"
                type="textarea"
                rows="3"
                placeholder="请输入备注"
                style="width: 320px"
              />
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitPcForm">确认提交</el-button>
          </div>
        </el-dialog>

        <!-- ====================== PC 独立弹窗：赏品列表 ====================== -->
        <el-dialog
          title="赏品列表"
          :visible.sync="pcBoxDialogVisible"
          width="1200px"
          append-to-body
        >
          <div style="text-align: left; margin-bottom: 10px">
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="openPcGoodsSelect"
              >添加赏品</el-button
            >
          </div>

          <div style="margin-bottom: 15px">
            <div style="margin-bottom: 8px; font-weight: bold; color: #333">
              待保存赏品（可编辑）
            </div>
            <el-table
              :data="pcTempGoodsList"
              border
              stripe
              size="small"
              style="background: #fef8f0"
            >
              <el-table-column label="ID" prop="id" width="70" align="center" />
              <el-table-column label="赏品图片" align="center" width="100">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.image"
                    style="
                      width: 50px;
                      height: 50px;
                      object-fit: cover;
                      border-radius: 4px;
                    "
                  />
                </template>
              </el-table-column>
              <el-table-column label="商品名称" prop="title" min-width="200" />
              <el-table-column label="商品类型" width="130" align="center">
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row.goods_type == 1
                        ? "真实赏品"
                        : scope.row.goods_type == 2
                        ? "虚拟赏品"
                        : "-"
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="等级" width="110" align="center">
                <template slot-scope="scope">
                  <el-select
                    v-model.number="scope.row.level_id"
                    style="width: 100px"
                  >
                    <el-option
                      v-for="lvl in roomLevelList"
                      :key="lvl.level_id"
                      :label="lvl.name"
                      :value="lvl.level_id"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="价格" width="100" align="center">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.price"
                    type="number"
                    style="width: 90px"
                  />
                </template>
              </el-table-column>
              <el-table-column label="兑换价格" width="120" align="center">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.recovery_price"
                    type="number"
                    style="width: 110px"
                  />
                </template>
              </el-table-column>
              <el-table-column label="原始数量" width="100" align="center">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.quantity"
                    type="number"
                    style="width: 90px"
                  />
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click="removePcTempGoods(scope.row)"
                    style="color: #f56c6c"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div style="margin-bottom: 15px">
            <div style="margin-bottom: 8px; font-weight: bold; color: #333">
              已保存数据（数据库）
            </div>
            <el-table
              :data="pcBoxList"
              border
              stripe
              size="small"
              v-loading="pcBoxLoading"
            >
              <el-table-column label="ID" prop="id" width="80" align="center" />
              <el-table-column label="赏品图片" align="center" width="120">
                <template slot-scope="scope">
                  <img
                    :src="scope.row.goods_image"
                    style="
                      width: 60px;
                      height: 60px;
                      object-fit: cover;
                      border-radius: 4px;
                    "
                  />
                </template>
              </el-table-column>
              <el-table-column
                label="商品名称"
                prop="goods_title"
                min-width="260"
              />
              <!-- <el-table-column
                label="配置中奖用户"
                min-width="260"
                align="center"
              >
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.user_id"
                    placeholder="输入用户ID"
                    size="mini"
                    style="width: 120px"
                    clearable
                  />
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-check"
                    style="margin-left: 5px"
                    @click.stop="handleSetPrizeUser(scope.row)"
                  >
                    确认
                  </el-button>
                </template>
              </el-table-column> -->
              <el-table-column
                label="商品类型"
                prop="goods_type_desc"
                min-width="120"
              />

              <el-table-column
                label="等级"
                prop="level_name"
                width="100"
                align="center"
              />
              <el-table-column
                label="价值"
                prop="price"
                width="120"
                align="center"
              />
              <el-table-column
                label="创建时间"
                prop="created_at"
                width="180"
                align="center"
              />
              <el-table-column label="操作" width="180" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    icon="el-icon-edit"
                    @click.stop="handlePcEditBox(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    @click.stop="handlePcDelBox(scope.row)"
                    style="color: #f56c6c"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div style="text-align: right; margin-top: 15px">
            <el-pagination
              @size-change="handlePcBoxSizeChange"
              @current-change="handlePcBoxCurrentChange"
              :current-page="pcBoxSearch.page"
              :page-size="pcBoxSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pcBoxTotal"
            ></el-pagination>
          </div>

          <div style="text-align: right; margin-top: 15px">
            <el-button @click="pcBoxDialogVisible = false">关闭弹窗</el-button>
            <el-button
              type="success"
              icon="el-icon-check"
              @click="savePcTempGoods"
              >确认保存所有赏品</el-button
            >
          </div>

          <el-dialog
            title="编辑已保存赏品"
            :visible.sync="pcEditBoxDialogVisible"
            width="500px"
            append-to-body
          >
            <el-form :model="pcEditBoxForm" label-width="100px" size="small">
              <el-form-item label="赏品图片">
                <img
                  :src="pcEditBoxForm.goods_image"
                  style="
                    width: 70px;
                    height: 70px;
                    object-fit: cover;
                    border-radius: 4px;
                  "
                />
              </el-form-item>
              <el-form-item label="商品名称">
                <span>{{ pcEditBoxForm.goods_title }}</span>
              </el-form-item>
              <el-form-item label="赏品类型">
                <span>
                  {{
                    pcEditBoxForm.goods_type == 1
                      ? "真实赏品"
                      : pcEditBoxForm.goods_type == 2
                      ? "虚拟赏品"
                      : "-"
                  }}
                </span>
              </el-form-item>
              <el-form-item label="等级">
                <el-select
                  v-model.number="pcEditBoxForm.level_id"
                  style="width: 100%"
                >
                  <el-option
                    v-for="lvl in roomLevelList"
                    :key="lvl.level_id"
                    :label="lvl.name"
                    :value="lvl.level_id"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="价格">
                <el-input v-model.number="pcEditBoxForm.price" type="number" />
              </el-form-item>
              <el-form-item label="兑换价格">
                <el-input
                  v-model.number="pcEditBoxForm.recovery_price"
                  type="number"
                />
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button @click="pcEditBoxDialogVisible = false"
                >取消</el-button
              >
              <el-button type="primary" @click="submitPcEditBox"
                >确认保存</el-button
              >
            </div>
          </el-dialog>
        </el-dialog>

        <!-- ====================== PC 独立弹窗：选择赏品 ====================== -->
        <el-dialog
          title="选择赏品（支持多选）"
          :visible.sync="pcGoodsDialogVisible"
          width="1200px"
          append-to-body
        >
          <div
            style="
              display: flex;
              gap: 10px;
              margin-bottom: 10px;
              flex-wrap: wrap;
            "
          >
            <el-input
              v-model="pcGoodsSearch.title"
              placeholder="商品名称"
              style="width: 180px"
              clearable
            ></el-input>
            <el-select
              v-model="pcLevelType"
              placeholder="请选择类型分组"
              style="width: 160px"
              clearable
              @change="pcLevelTypeChange"
            >
              <el-option
                v-for="item in pcGoodsLevelGroup"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>
            <el-select
              v-model="pcGoodsSearch.level_id"
              placeholder="请选择等级"
              style="width: 160px"
              clearable
            >
              <el-option
                v-for="item in pcCurrentLevelList"
                :key="item.level_id"
                :label="item.name"
                :value="item.level_id"
              />
            </el-select>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="getPcGoodsList"
              >搜索</el-button
            >
            <el-button icon="el-icon-refresh" @click="resetPcGoodsSearch"
              >重置</el-button
            >
          </div>

          <el-table
            :data="pcGoodsList"
            border
            stripe
            size="small"
            v-loading="pcGoodsLoading"
            ref="pcGoodsTable"
            @selection-change="handlePcGoodsSelectionChange"
            @row-click="handlePcRowSelect"
          >
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column label="ID" prop="id" width="70" align="center" />
            <el-table-column label="商品图片" align="center" width="100">
              <template slot-scope="scope">
                <img
                  :src="scope.row.image"
                  style="width: 50px; height: 50px; object-fit: cover"
                />
              </template>
            </el-table-column>
            <el-table-column label="商品名称" prop="title" min-width="260" />
            <el-table-column
              label="等级"
              prop="level_name"
              width="100"
              align="center"
            />
            <el-table-column label="赏品类型" width="100" align="center">
              <template slot-scope="scope">
                <span
                  :style="
                    scope.row.goods_type == 1
                      ? 'color:#409EFF'
                      : 'color:#67C23A'
                  "
                >
                  {{
                    scope.row.goods_type == 1
                      ? "真实赏品"
                      : scope.row.goods_type == 2
                      ? "虚拟赏品"
                      : "-"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="类型"
              prop="type_name"
              width="100"
              align="center"
            />
            <el-table-column
              label="价值"
              prop="price"
              width="120"
              align="center"
            />
            <el-table-column
              label="创建时间"
              prop="created_at"
              width="180"
              align="center"
            />
          </el-table>

          <div style="text-align: right; margin-top: 15px">
            <el-pagination
              @size-change="handlePcGoodsSizeChange"
              @current-change="handlePcGoodsCurrentChange"
              :current-page="pcGoodsSearch.page"
              :page-size="pcGoodsSearch.page_size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pcGoodsTotal"
            ></el-pagination>
          </div>

          <div slot="footer" style="text-align: right">
            <el-button @click="pcGoodsDialogVisible = false">取消</el-button>
            <el-button type="success" @click="confirmPcAddGoods"
              >确认添加选中赏品</el-button
            >
          </div>
        </el-dialog>

        <!-- ====================== PC 独立弹窗：详情 ====================== -->
        <el-dialog
          title="详情"
          :visible.sync="pcDetailDialogVisible"
          width="850px"
          append-to-body
        >
          <div class="detail-content" v-loading="pcDetailLoading">
            <div v-if="pcDetailRow" style="padding: 10px 0">
              <el-descriptions :column="2" border size="small">
                <el-descriptions-item label="ID">{{
                  pcDetailRow.id
                }}</el-descriptions-item>
                <el-descriptions-item label="福利屋名称">{{
                  pcDetailRow.name
                }}</el-descriptions-item>
                <el-descriptions-item label="周期类型">{{
                  pcDetailRow.room_type_name
                }}</el-descriptions-item>

                <el-descriptions-item label="流水金额">{{
                  pcDetailRow.amount
                }}</el-descriptions-item>
                <el-descriptions-item label="充值金额">{{
                  pcDetailRow.recharge_amount
                }}</el-descriptions-item>
                <el-descriptions-item label="活动状态">
                  <span
                    :style="{
                      color:
                        pcDetailRow.status == 0
                          ? '#67C23A'
                          : pcDetailRow.status == 1
                          ? '#409EFF'
                          : '#909399',
                    }"
                  >
                    {{
                      pcDetailRow.status == 0
                        ? "待开始"
                        : pcDetailRow.status == 1
                        ? "进行中"
                        : "已结束"
                    }}
                  </span>
                </el-descriptions-item>
                <el-descriptions-item label="剩余时间">{{
                  formatRemainTime(pcDetailRow.draw_at, pcDetailRow.status)
                }}</el-descriptions-item>
                <el-descriptions-item label="开始时间">{{
                  pcDetailRow.start_at
                }}</el-descriptions-item>
                <el-descriptions-item label="结束时间">{{
                  pcDetailRow.end_at
                }}</el-descriptions-item>
                <el-descriptions-item label="开奖时间">{{
                  pcDetailRow.draw_at
                }}</el-descriptions-item>
                <el-descriptions-item label="创建时间">{{
                  pcDetailRow.created_at
                }}</el-descriptions-item>
                <el-descriptions-item label="更新时间">{{
                  pcDetailRow.updated_at
                }}</el-descriptions-item>
              </el-descriptions>
            </div>
          </div>
          <div slot="footer">
            <el-button @click="pcDetailDialogVisible = false">关闭</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- ====================== PC 独立弹窗：参与用户列表 ====================== -->
    <el-dialog
      title="参与用户列表"
      :visible.sync="userAttendVisible"
      width="1200px"
      append-to-body
    >
      <!-- 添加用户按钮 -->
      <div style="text-align: left; margin-bottom: 10px">
        <el-button type="success" icon="el-icon-user-add" @click="openAddUser">
          添加用户
        </el-button>
      </div>
      <el-table
        :data="userAttendList"
        border
        stripe
        size="small"
        v-loading="userAttendLoading"
        style="width: 100%"
      >
        <el-table-column
          label="用户ID"
          prop="user_id"
          width="100"
          align="center"
        />
        <el-table-column label="用户昵称" prop="nickname" min-width="150" />
        <el-table-column label="头像" align="center" width="80">
          <template slot-scope="scope">
            <img
              :src="scope.row.avatar"
              style="width: 40px; height: 40px; border-radius: 50%"
            />
          </template>
        </el-table-column>
        <el-table-column label="是否中奖" width="100" align="center">
          <template slot-scope="scope">
            <span
              :style="
                scope.row.is_hit == 1
                  ? 'color:#409EFF;font-weight:bold'
                  : 'color:#999'
              "
            >
              {{ scope.row.is_hit == 1 ? "已中奖" : "未中奖" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="中奖赏品" align="center" width="120">
          <template slot-scope="scope">
            <img
              :src="scope.row.goods_image"
              style="
                width: 50px;
                height: 50px;
                object-fit: cover;
                border-radius: 4px;
              "
            />
          </template>
        </el-table-column>
        <el-table-column label="赏品名称" prop="goods_name" min-width="160" />
        <el-table-column
          label="赏品价值"
          prop="price"
          width="100"
          align="center"
        />
        <el-table-column
          label="回收价格"
          prop="recovery_price"
          width="110"
          align="center"
        />
        <el-table-column
          label="参与时间"
          prop="created_at"
          width="180"
          align="center"
        />
      </el-table>

      <div style="text-align: right; margin-top: 15px">
        <el-pagination
          @size-change="handleUserAttendSizeChange"
          @current-change="handleUserAttendCurrentChange"
          :current-page="userAttendSearch.page"
          :page-size="userAttendSearch.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="userAttendTotal"
        ></el-pagination>
      </div>
      <!-- 子弹窗：手动添加参与用户 -->
      <el-dialog
        title="手动添加参与用户"
        :visible.sync="addUserVisible"
        width="500px"
        append-to-body
      >
        <el-form :model="addUserForm" label-width="100px" size="small">
          <el-form-item label="用户ID" required>
            <el-input
              v-model.number="addUserForm.user_id"
              placeholder="请输入用户ID"
              style="width: 280px"
            />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="addUserVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAddUser">确认添加</el-button>
        </div>
      </el-dialog>
      <div slot="footer">
        <el-button @click="userAttendVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.name"
            placeholder="福利屋名称"
            clearable
            size="medium"
            prefix-icon="el-icon-search"
          />
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model.number="searchParams.type"
              placeholder="周期类型"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option
                v-for="item in typeList"
                :key="item.type"
                :label="item.desc"
                :value="item.type"
              />
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-select
              v-model.number="searchParams.status"
              placeholder="活动状态"
              clearable
              size="medium"
              style="flex: 1"
            >
              <el-option label="待开始" :value="0" />
              <el-option label="进行中" :value="1" />
              <el-option label="已结束" :value="2" />
            </el-select>
          </div>
          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
            >
              搜索
            </el-button>
            <el-button plain round @click="resetSearch" style="flex: 1">
              重置
            </el-button>
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="openMobileDetail(item)"
          >
            <div class="card-header">
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="meta">
                  ID:{{ item.id }} | {{ item.room_type_name }}
                </div>
                <div class="meta">
                  流水:{{ item.amount }} | 充值:{{ item.recharge_amount }}
                </div>
              </div>
              <div class="status" :class="getStatusClass(item.status)">
                {{ getStatusText(item.status) }}
              </div>
            </div>
            <div class="card-body">
              <div>剩余：{{ formatRemainTime(item.draw_at, item.status) }}</div>
              <div>开奖：{{ item.draw_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="openMobileEdit(item.id)"
                >编辑</el-button
              >
              <!-- 新增：参与用户 -->
              <el-button
                size="mini"
                type="success"
                round
                @click.stop="openMobileUserList(item)"
                style="margin-left: 8px"
                >参与用户</el-button
              >
              <el-button
                size="mini"
                type="danger"
                round
                @click.stop="handleMobileDel(item)"
                style="margin-left: 8px"
                >删除</el-button
              >
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageTotal"
            pager-count="2"
            small
          />
        </div>

        <!-- ====================== 移动端独立弹窗：详情 ====================== -->
        <el-dialog
          title="福利屋详情"
          :visible.sync="mobileDetailVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileDetailRow" style="padding: 10px">
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="ID">{{
                mobileDetailRow.id
              }}</el-descriptions-item>
              <el-descriptions-item label="名称">{{
                mobileDetailRow.name
              }}</el-descriptions-item>
              <el-descriptions-item label="周期类型">{{
                mobileDetailRow.room_type_name
              }}</el-descriptions-item>
              <el-descriptions-item label="流水金额">{{
                mobileDetailRow.amount
              }}</el-descriptions-item>
              <el-descriptions-item label="充值金额">{{
                mobileDetailRow.recharge_amount
              }}</el-descriptions-item>
              <el-descriptions-item label="状态">
                <span :style="getStatusStyle(mobileDetailRow.status)">
                  {{ getStatusText(mobileDetailRow.status) }}
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="剩余时间">{{
                formatRemainTime(
                  mobileDetailRow.draw_at,
                  mobileDetailRow.status
                )
              }}</el-descriptions-item>
              <el-descriptions-item label="开始时间">{{
                mobileDetailRow.start_at
              }}</el-descriptions-item>
              <el-descriptions-item label="结束时间">{{
                mobileDetailRow.end_at
              }}</el-descriptions-item>
              <el-descriptions-item label="开奖时间">{{
                mobileDetailRow.draw_at
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileDetailVisible = false">关闭</el-button>
          </div>
        </el-dialog>
        <!-- ====================== 移动端：参与用户列表 ====================== -->
        <el-dialog
          title="参与用户"
          :visible.sync="mobileUserVisible"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div style="text-align: left; margin-bottom: 10px">
            <el-button
              type="success"
              round
              size="mini"
              icon="el-icon-user-add"
              @click="openMobileAddUser"
            >
              添加用户
            </el-button>
          </div>

          <div v-loading="mobileUserLoading">
            <div
              v-for="item in mobileUserList"
              :key="item.id"
              style="
                padding: 12px;
                border-bottom: 1px solid #eee;
                display: flex;
                align-items: center;
                gap: 10px;
              "
            >
              <!-- 头像 -->
              <img
                :src="item.avatar"
                style="width: 50px; height: 50px; border-radius: 50%"
              />

              <!-- 用户信息 + 中奖信息 -->
              <div style="flex: 1">
                <div style="font-weight: bold; font-size: 14px">
                  用户ID：{{ item.user_id }}
                </div>
                <div style="font-size: 12px; color: #666; margin: 2px 0">
                  昵称：{{ item.nickname || "未设置" }}
                </div>
                <div style="font-size: 12px; color: #999">
                  参与时间：{{ item.created_at }}
                </div>

                <!-- 中奖信息 -->
                <div
                  style="
                    margin-top: 6px;
                    display: flex;
                    align-items: center;
                    gap: 6px;
                  "
                >
                  <span
                    :style="
                      item.is_hit == 1
                        ? 'color:#409EFF;font-weight:bold'
                        : 'color:#999'
                    "
                  >
                    {{ item.is_hit == 1 ? "✅ 已中奖" : "未中奖" }}
                  </span>

                  <span
                    v-if="item.is_hit == 1"
                    style="font-size: 12px; color: #f56c6c"
                  >
                    奖品：{{ item.goods_name }} | 价值 ¥{{ item.price }}
                  </span>
                </div>
              </div>

              <!-- 中奖商品小图 -->
              <img
                v-if="item.is_hit == 1"
                :src="item.goods_image"
                style="
                  width: 45px;
                  height: 45px;
                  border-radius: 6px;
                  object-fit: cover;
                "
              />
            </div>

            <div
              v-if="mobileUserList.length === 0"
              style="text-align: center; padding: 30px; color: #999"
            >
              暂无参与用户
            </div>
          </div>

          <div slot="footer">
            <el-button @click="mobileUserVisible = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- ====================== 移动端：手动添加用户 ====================== -->
        <el-dialog
          title="添加参与用户"
          :visible.sync="mobileAddUserVisible"
          width="90%"
          append-to-body
        >
          <el-form label-width="80px" size="small">
            <el-form-item label="用户ID">
              <el-input
                v-model.number="mobileAddUserForm.user_id"
                placeholder="请输入用户ID"
              />
            </el-form-item>
          </el-form>
          <div slot="footer">
            <el-button @click="mobileAddUserVisible = false">取消</el-button>
            <el-button type="primary" @click="submitMobileAddUser"
              >确认添加</el-button
            >
          </div>
        </el-dialog>
        <!-- ====================== 移动端独立弹窗：编辑 ====================== -->
        <el-dialog
          title="编辑福利屋"
          :visible.sync="mobileEditVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileEditForm"
            :rules="addRules"
            ref="mobileEditRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="mobileEditForm.name"
                placeholder="名称"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="周期类型" prop="type">
              <el-select
                v-model.number="mobileEditForm.type"
                placeholder="请选择"
                size="medium"
                style="width: 100%"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="流水金额" prop="amount">
              <el-input
                v-model.number="mobileEditForm.amount"
                placeholder="流水"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="充值金额" prop="recharge_amount">
              <el-input
                v-model.number="mobileEditForm.recharge_amount"
                placeholder="充值"
                size="medium"
              />
            </el-form-item>
            <el-form-item label="开始时间" prop="start_at">
              <el-date-picker
                v-model="mobileEditForm.start_at"
                type="datetime"
                placeholder="开始时间"
                size="medium"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="end_at">
              <el-date-picker
                v-model="mobileEditForm.end_at"
                type="datetime"
                placeholder="结束时间"
                size="medium"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="开奖时间" prop="draw_at">
              <el-date-picker
                v-model="mobileEditForm.draw_at"
                type="datetime"
                placeholder="开奖时间"
                size="medium"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                v-model="mobileEditForm.content"
                type="textarea"
                rows="2"
                placeholder="备注"
                size="medium"
              />
            </el-form-item>
          </el-form>

          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              justify-content: flex-end;
              gap: 10px;
            "
          >
            <el-button size="medium" @click="mobileEditVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileEdit"
              >保存</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "WealRooms",
  data() {
    return {
      loading: false,
      tableData: [],
      pageTotal: 0,
      typeList: [],
      goodsTypeList: [],
      roomLevelList: [],
      searchParams: {
        page: 1,
        page_size: 10,
        name: "",
        type: "",
        goods_type: "",
        status: "",
      },
      columnOptions: [
        { label: "ID", prop: "id" },
        { label: "福利屋名称", prop: "name" },
        { label: "周期类型", prop: "room_type_name" },
        { label: "赏品类型", prop: "goods_type_name" },
        { label: "流水金额", prop: "amount" },
        { label: "充值金额", prop: "recharge_amount" },
        { label: "活动状态", prop: "status_text" },
        { label: "剩余时间", prop: "remainText" },
        { label: "开始时间", prop: "start_at" },
        { label: "结束时间", prop: "end_at" },
        { label: "开奖时间", prop: "draw_at" },
        { label: "创建时间", prop: "created_at" },
        { label: "更新时间", prop: "updated_at" },
        { label: "操作", prop: "action" },
      ],
      checkedColumns: [
        "id",
        "name",
        "room_type_name",
        "goods_type_name",
        "amount",
        "recharge_amount",
        "status_text",
        "remainText",
        "start_at",
        "end_at",
        "draw_at",
        "created_at",
        "updated_at",
        "action",
      ],
      addRules: {
        name: [
          { required: true, message: "请输入福利屋名称", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请选择周期类型", trigger: "change" },
        ],
        goods_type: [
          { required: true, message: "请选择赏品类型", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入流水金额", trigger: "blur" },
        ],
        start_at: [
          { required: true, message: "请选择开始时间", trigger: "change" },
        ],
        end_at: [
          { required: true, message: "请选择结束时间", trigger: "change" },
        ],
        draw_at: [
          { required: true, message: "请选择开奖时间", trigger: "change" },
        ],
      },

      // ====================== PC 独立弹窗数据 ======================
      pcDialogVisible: false,
      pcForm: {
        room_id: "",
        name: "",
        type: "",
        goods_type: "",
        amount: 0,
        recharge_amount: 0,
        start_at: "",
        end_at: "",
        draw_at: "",
        content: "",
      },
      pcBoxDialogVisible: false,
      pcBoxList: [],
      pcBoxTotal: 0,
      pcBoxLoading: false,
      pcBoxSearch: { page: 1, page_size: 10, room_id: "" },
      pcTempGoodsList: [],
      pcGoodsDialogVisible: false,
      pcGoodsList: [],
      pcGoodsTotal: 0,
      pcGoodsLoading: false,
      pcSelectedGoods: [],
      pcGoodsSearch: {
        page: 1,
        page_size: 15,
        title: "",
        type: "",
        level_id: "",
        flag: 5,
      },
      pcGoodsLevelGroup: [],
      pcLevelType: "",
      pcCurrentLevelList: [],
      pcDetailDialogVisible: false,
      pcDetailRow: null,
      pcDetailLoading: false,
      pcEditBoxDialogVisible: false,
      pcEditBoxForm: {
        prize_id: "",
        goods_id: "",
        goods_title: "",
        goods_image: "",
        level_id: "",
        price: "",
        recovery_price: "",
      },
      pcGoodsTypeList: [], // 新增：真实/虚拟商品类型
      // ====================== 移动端独立弹窗数据 ======================
      mobileDetailVisible: false,
      mobileDetailRow: null,
      mobileEditVisible: false,
      mobileEditForm: {
        room_id: "",
        name: "",
        type: "",
        goods_type: "",
        amount: 0,
        recharge_amount: 0,
        start_at: "",
        end_at: "",
        draw_at: "",
        content: "",
      },

      // 参与用户弹窗
      userAttendVisible: false,
      userAttendList: [],
      userAttendTotal: 0,
      userAttendLoading: false,
      userAttendSearch: {
        page: 1,
        page_size: 10,
        room_id: "",
      },
      // 新增：手动添加用户
      addUserVisible: false,
      addUserForm: {
        user_id: "",
        room_id: "",
      },
      // 移动端 - 参与用户
      mobileUserVisible: false,
      mobileUserList: [],
      mobileUserLoading: false,
      mobileAddUserVisible: false,
      mobileAddUserForm: {
        user_id: "",
        room_id: "",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // ====================== 公共方法 ======================
    getList() {
      this.loading = true;
      api.wealRooms
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            let list = res.data.data.data || [];
            list.forEach((item) => this.setActivityStatus(item));
            this.tableData = list;
            this.typeList = res.data.data.type_data || [];
            this.goodsTypeList = res.data.data.goods_type_data || [];
            this.roomLevelList = res.data.data.level || [];
            this.pageTotal = res.data.data.total || 0;
          }
        })
        .finally(() => (this.loading = false));
    },
    setActivityStatus(item) {},
    formatRemainTime(timeStr, status) {
      if (status !== 1) return "-";
      if (!timeStr) return "-";
      let end = new Date(timeStr).getTime();
      let now = Date.now();
      let diff = end - now;
      if (diff <= 0) return "已开奖";
      const day = 24 * 3600 * 1000;
      const hour = 3600 * 1000;
      const minute = 60 * 1000;
      let days = Math.floor(diff / day);
      let hours = Math.floor((diff % day) / hour);
      let minutes = Math.floor((diff % hour) / minute);
      return `${days}天${hours}时${minutes}分`;
    },
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        name: "",
        type: "",
        goods_type: "",
        status: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
    handleCheckAll() {
      this.checkedColumns = this.columnOptions.map((item) => item.prop);
    },
    handleClearAll() {
      this.checkedColumns = [];
    },
    // 打开参与用户列表
    openUserAttendList(row) {
      this.userAttendSearch.room_id = row.id;
      this.userAttendSearch.page = 1;
      this.getUserAttendList();
      this.userAttendVisible = true;
    },

    // 获取参与用户列表
    getUserAttendList() {
      this.userAttendLoading = true;
      api.wealRooms
        .userAttendList({ params: this.userAttendSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.userAttendList = res.data.data.data || [];
            this.userAttendTotal = res.data.data.total || 0;
          }
        })
        .finally(() => (this.userAttendLoading = false));
    },

    // 分页切换
    handleUserAttendCurrentChange(val) {
      this.userAttendSearch.page = val;
      this.getUserAttendList();
    },
    handleUserAttendSizeChange(val) {
      this.userAttendSearch.page_size = val;
      this.getUserAttendList();
    },
    // 打开添加用户弹窗
    openAddUser() {
      this.addUserForm = {
        user_id: "",
        room_id: this.userAttendSearch.room_id,
      };
      this.addUserVisible = true;
    },

    // 提交添加用户
    submitAddUser() {
      if (!this.addUserForm.user_id) {
        return this.$message.warning("请输入用户ID");
      }
      api.wealRooms.adminUserAttend(this.addUserForm).then((res) => {
        if (res.data.code == 1000) {
          this.addUserVisible = false;
          this.getUserAttendList(); // 刷新列表
        }
      });
    },
    // 配置中奖用户（用户ID绑定赏品）
    // async handleSetPrizeUser(row) {
    //   const user_id = row.user_id || "";

    //   if (!user_id) {
    //     return this.$message.warning("请输入用户ID");
    //   }

    //   await this.$confirm(
    //     `确定将用户ID【${user_id}】配置为该赏品的中奖用户？`,
    //     "提示",
    //     {
    //       type: "info",
    //     }
    //   ).catch(() => {
    //     return Promise.reject("取消");
    //   });

    //   try {
    //     const res = await api.wealRooms.userAttend({
    //       prize_id: row.id,
    //       user_id: user_id,
    //     });

    //     if (res.data.code === 1000) {
    //       row.luck_code = "";
    //     } else {
    //     }
    //   } catch (err) {
    //     console.error(err);
    //   }
    // },
    // ====================== PC 独立弹窗方法 ======================
    handleAdd() {
      this.resetPcForm();
      this.pcDialogVisible = true;
    },
    handleEdit(row) {
      this.pcForm = { ...row, room_id: row.id };
      this.pcDialogVisible = true;
    },
    resetPcForm() {
      this.pcForm = {
        room_id: "",
        name: "",
        type: "",
        goods_type: "",
        amount: 0,
        recharge_amount: 0,
        start_at: "",
        end_at: "",
        draw_at: "",
        content: "",
      };
    },
    submitPcForm() {
      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        const isEdit = !!this.pcForm.room_id;
        const data = { ...this.pcForm };
        if (!isEdit) delete data.room_id;
        const apiCall = isEdit
          ? api.wealRooms.edit(data)
          : api.wealRooms.add(data);
        apiCall.then((res) => {
          if (res.data.code == 1000) {
            this.pcDialogVisible = false;
            this.getList();
          }
        });
      });
    },
    handleDelWealRoom(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" }).then(() => {
        api.wealRooms.del({ room_id: row.id }).then((res) => {
          if (res.data.code == 1000) this.getList();
        });
      });
    },
    openBoxList(row) {
      if (this.pcBoxSearch.room_id != row.id) this.pcTempGoodsList = [];
      this.pcBoxSearch.room_id = row.id;
      this.pcBoxSearch.page = 1;
      this.getPcBoxList();
      this.pcBoxDialogVisible = true;
    },
    getPcBoxList() {
      this.pcBoxLoading = true;
      api.wealRooms
        .boxList({ params: this.pcBoxSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.pcBoxList = res.data.data.data || [];
            this.pcBoxTotal = res.data.data.total || 0;
          }
        })
        .finally(() => (this.pcBoxLoading = false));
    },
    handlePcBoxCurrentChange(val) {
      this.pcBoxSearch.page = val;
      this.getPcBoxList();
    },
    handlePcBoxSizeChange(val) {
      this.pcBoxSearch.page_size = val;
      this.getPcBoxList();
    },
    openPcGoodsSelect() {
      this.pcGoodsSearch.page = 1;
      this.getPcGoodsList(() => {
        this.$nextTick(() => {
          const table = this.$refs.pcGoodsTable;
          if (!table) return;
          this.pcGoodsList.forEach((item) => {
            const exist = this.pcTempGoodsList.some((g) => g.id == item.id);
            table.toggleRowSelection(item, exist);
          });
        });
      });
      this.pcGoodsDialogVisible = true;
    },
    getPcGoodsList(callback) {
      this.pcGoodsLoading = true;
      api.goods
        .index({ params: this.pcGoodsSearch })
        .then((res) => {
          if (res.data.code == 1000) {
            this.pcGoodsList = res.data.data.data || [];
            this.pcGoodsTotal = res.data.data.total || 0;
            this.pcGoodsLevelGroup = res.data.data.goods_level || [];
            this.pcGoodsTypeList = res.data.data.goods_type || [];
          }
          callback && callback();
        })
        .finally(() => (this.pcGoodsLoading = false));
    },
    pcLevelTypeChange() {
      this.pcGoodsSearch.level_id = "";
      let group = this.pcGoodsLevelGroup.find(
        (item) => item.type == this.pcLevelType
      );
      this.pcGoodsSearch.type = group.type;
      this.pcCurrentLevelList = group ? group.goods_level || [] : [];
    },
    handlePcRowSelect(row) {
      this.$refs.pcGoodsTable.toggleRowSelection(row);
    },
    handlePcGoodsSelectionChange(val) {
      this.pcSelectedGoods = val;
    },
    confirmPcAddGoods() {
      if (this.pcSelectedGoods.length === 0)
        return this.$message.warning("请选择赏品");

      this.pcSelectedGoods.forEach((item) => {
        // ============== 核心逻辑 ==============
        // 真实赏品：去重（判断ID是否已存在）
        // 虚拟赏品：允许重复，不判断
        const isVirtual = item.goods_type == 2;
        const isExist = this.pcTempGoodsList.some((g) => g.id == item.id);

        // 真实赏品 + 已存在 → 跳过
        if (!isVirtual && isExist) {
          return;
        }

        // 虚拟赏品 或 真实赏品不存在 → 添加
        this.pcTempGoodsList.push({
          ...item,
          level_id:
            this.roomLevelList && this.roomLevelList.length > 0
              ? this.roomLevelList[0].level_id
              : 1,
          price: item.price || 0,
          recovery_price: item.price || 0,
          quantity: 1,
          goods_type: item.goods_type || "", // 保留类型
        });
      });

      this.$message.success("添加成功");
      this.pcGoodsDialogVisible = false;
      this.pcSelectedGoods = [];
    },
    removePcTempGoods(row) {
      this.pcTempGoodsList = this.pcTempGoodsList.filter((i) => i.id != row.id);
    },
    savePcTempGoods() {
      if (this.pcTempGoodsList.length === 0)
        return this.$message.warning("暂无赏品");
      const prize_info = this.pcTempGoodsList.map((item) => ({
        goods_id: item.id,
        level_id: item.level_id,
        price: item.price,
        recovery_price: item.recovery_price,
        goods_type: item.goods_type, // 新增
      }));
      api.wealRooms
        .addBoxPrize({
          room_id: this.pcBoxSearch.room_id,
          prize_info: JSON.stringify(prize_info),
        })
        .then((res) => {
          if (res.data.code == 1000) {
            this.pcTempGoodsList = [];
            this.getPcBoxList();
          }
        });
    },
    handlePcEditBox(row) {
      this.pcEditBoxForm = {
        prize_id: row.id,
        goods_id: row.goods_id,
        goods_title: row.goods_title,
        goods_image: row.goods_image,
        goods_type: row.goods_type, // 新增这一行
        level_id: row.level_id,
        price: row.price,
        recovery_price: row.recovery_price,
      };
      this.pcEditBoxDialogVisible = true;
    },
    submitPcEditBox() {
      api.wealRooms.editBoxPrize(this.pcEditBoxForm).then((res) => {
        if (res.data.code == 1000) {
          this.pcEditBoxDialogVisible = false;
          this.getPcBoxList();
        }
      });
    },
    handlePcDelBox(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" }).then(() => {
        api.wealRooms.delBoxPrize({ prize_id: row.id }).then((res) => {
          if (res.data.code == 1000) this.getPcBoxList();
        });
      });
    },
    handlePcGoodsCurrentChange(val) {
      this.pcGoodsSearch.page = val;
      this.getPcGoodsList();
    },
    handlePcGoodsSizeChange(val) {
      this.pcGoodsSearch.page_size = val;
      this.getPcGoodsList();
    },
    resetPcGoodsSearch() {
      this.pcGoodsSearch = {
        page: 1,
        page_size: 15,
        title: "",
        type: "",
        level_id: "",
        flag: 5,
      };
      this.pcLevelType = "";
      this.pcCurrentLevelList = [];
      this.getPcGoodsList();
    },
    handleRowClick(row) {
      this.pcDetailRow = row;
      this.pcDetailDialogVisible = true;
    },

    // ====================== 移动端独立弹窗方法 ======================
    openMobileDetail(row) {
      this.mobileDetailRow = JSON.parse(JSON.stringify(row));
      this.mobileDetailVisible = true;
    },
    openMobileEdit(id) {
      let row = this.tableData.find((item) => item.id == id);
      if (!row) return;
      this.mobileEditVisible = true;
      this.mobileEditForm = {
        room_id: row.id,
        name: row.name || "",
        type: row.type || "",
        goods_type: row.goods_type || "",
        amount: row.amount || 0,
        recharge_amount: row.recharge_amount || 0,
        start_at: row.start_at || "",
        end_at: row.end_at || "",
        draw_at: row.draw_at || "",
        content: row.content || "",
      };
    },
    async submitMobileEdit() {
      this.loading = true;
      try {
        const res = await api.wealRooms.edit(this.mobileEditForm);
        if (res.data.code == 1000) {
          this.mobileEditVisible = false;
          this.getList();
        }
      } finally {
        this.loading = false;
      }
    },
    handleMobileDel(row) {
      this.$confirm("确定删除？", "提示", { type: "warning" }).then(() => {
        api.wealRooms.del({ room_id: row.id }).then((res) => {
          if (res.data.code == 1000) this.getList();
        });
      });
    },
    getStatusText(s) {
      return s == 0 ? "待开始" : s == 1 ? "进行中" : "已结束";
    },
    getStatusClass(s) {
      return s == 1 ? "on" : s == 0 ? "waiting" : "off";
    },
    getStatusStyle(s) {
      return s == 0
        ? "color:#67C23A"
        : s == 1
        ? "color:#409EFF"
        : "color:#909399";
    },
    // ================ 移动端 - 参与用户 ================
    openMobileUserList(row) {
      this.mobileAddUserForm.room_id = row.id;
      this.mobileUserVisible = true;
      this.getMobileUserList();
    },
    getMobileUserList() {
      this.mobileUserLoading = true;
      api.wealRooms
        .userAttendList({
          params: {
            page: 1,
            page_size: 999,
            room_id: this.mobileAddUserForm.room_id,
          },
        })
        .then((res) => {
          if (res.data.code == 1000) {
            this.mobileUserList = res.data.data.data || [];
          }
        })
        .finally(() => {
          this.mobileUserLoading = false;
        });
    },
    openMobileAddUser() {
      this.mobileAddUserForm.user_id = "";
      this.mobileAddUserVisible = true;
    },
    submitMobileAddUser() {
      if (!this.mobileAddUserForm.user_id) {
        return this.$message.warning("请输入用户ID");
      }
      api.wealRooms.adminUserAttend(this.mobileAddUserForm).then((res) => {
        if (res.data.code == 1000) {
          this.mobileAddUserVisible = false;
          this.getMobileUserList();
        }
      });
    },
  },
};
</script>

<style scoped>
/* PC */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

/* 移动端 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.status {
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 4px;
}
.status.on {
  background: #e6f7ff;
  color: #409eff;
}
.status.waiting {
  background: #f0f9f0;
  color: #67c23a;
}
.status.off {
  background: #f5f5f5;
  color: #909399;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/pages/weal/index.vue